// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.close-button_close-button_hF872 {
    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;  /* Mask the icon animation */
    background-color: var(--ui-black-transparent);
    border-radius: 50%;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
    transition: all 0.15s ease-out;
}

.close-button_close-button_hF872.close-button_large_ssrHq:hover {
    transform: scale(1.1, 1.1);
    box-shadow: 0 0 0 4px var(--ui-black-transparent);
}

.close-button_close-button_hF872.close-button_large_ssrHq.close-button_orange_CKQIK:hover {
    transform: scale(1.1, 1.1);
    box-shadow: 0px 0px 0px 4px hsla(29, 100%, 54%, 0.2);
}

.close-button_small_b8FTl {
    width: 0.825rem;
    height: 0.825rem;
    background-color: var(--looks-secondary);
    color: var(--ui-white);
}

.close-button_large_ssrHq {
    width: 1.75rem;
    height: 1.75rem;
    box-shadow: 0 0 0 2px var(--ui-black-transparent);
}

.close-button_large_ssrHq.close-button_orange_CKQIK {
    background-color: hsla(29, 100%, 54%, 0.2);
    box-shadow: 0px 0px 0px 2px hsla(29, 100%, 54%, 0.2);
}

.close-button_close-icon_sO3ll {
    position: relative;
    margin: 0.25rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    transform-origin: 50%;
    transform: rotate(45deg);
}

.close-button_close-icon_sO3ll.close-button_orange_CKQIK {
    transform: rotate(45deg);
    transform: scale(1.4);
}

.close-button_small_b8FTl .close-button_close-icon_sO3ll {
    width: 50%;
}

.close-button_large_ssrHq .close-button_close-icon_sO3ll {
    width: 0.75rem;
    height: 0.75rem;
}

.close-button_back-icon_k75Wf {
  position: relative;
  margin: 0.25rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.close-button_small_b8FTl .close-button_back-icon_k75Wf {
    width: 50%;
}

.close-button_large_ssrHq .close-button_back-icon_k75Wf {
    width: 2rem;
    height: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/close-button/close-button.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,gBAAgB,GAAG,4BAA4B;IAC/C,6CAA6C;IAC7C,kBAAkB;IAClB,2DAA2D;IAC3D,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,iDAAiD;AACrD;;AAEA;IACI,0BAA0B;IAC1B,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,0CAA0C;IAC1C,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.close-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    overflow: hidden;  /* Mask the icon animation */\n    background-color: var(--ui-black-transparent);\n    border-radius: 50%;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n    transition: all 0.15s ease-out;\n}\n\n.close-button.large:hover {\n    transform: scale(1.1, 1.1);\n    box-shadow: 0 0 0 4px var(--ui-black-transparent);\n}\n\n.close-button.large.orange:hover {\n    transform: scale(1.1, 1.1);\n    box-shadow: 0px 0px 0px 4px hsla(29, 100%, 54%, 0.2);\n}\n\n.small {\n    width: 0.825rem;\n    height: 0.825rem;\n    background-color: var(--looks-secondary);\n    color: var(--ui-white);\n}\n\n.large {\n    width: 1.75rem;\n    height: 1.75rem;\n    box-shadow: 0 0 0 2px var(--ui-black-transparent);\n}\n\n.large.orange {\n    background-color: hsla(29, 100%, 54%, 0.2);\n    box-shadow: 0px 0px 0px 2px hsla(29, 100%, 54%, 0.2);\n}\n\n.close-icon {\n    position: relative;\n    margin: 0.25rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    transform-origin: 50%;\n    transform: rotate(45deg);\n}\n\n.close-icon.orange {\n    transform: rotate(45deg);\n    transform: scale(1.4);\n}\n\n.small .close-icon {\n    width: 50%;\n}\n\n.large .close-icon {\n    width: 0.75rem;\n    height: 0.75rem;\n}\n\n.back-icon {\n  position: relative;\n  margin: 0.25rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.small .back-icon {\n    width: 50%;\n}\n\n.large .back-icon {\n    width: 2rem;\n    height: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `close-button_close-button_hF872`;
export { _1 as "close-button" };
export var closeButton = `close-button_close-button_hF872`;
export var large = `close-button_large_ssrHq`;
export var orange = `close-button_orange_CKQIK`;
export var small = `close-button_small_b8FTl`;
var _2 = `close-button_close-icon_sO3ll`;
export { _2 as "close-icon" };
export var closeIcon = `close-button_close-icon_sO3ll`;
var _3 = `close-button_back-icon_k75Wf`;
export { _3 as "back-icon" };
export var backIcon = `close-button_back-icon_k75Wf`;
export default ___CSS_LOADER_EXPORT___;
